import { render } from "./TheBreadcrumb.vue?vue&type=template&id=13cf2afc&scoped=true&ts=true"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=ts"

import "./TheBreadcrumb.vue?vue&type=style&index=0&id=13cf2afc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cf2afc"]])

export default __exports__